import React from 'react';
import { AutoComplete, Col, Form, Input, Row, Space } from 'antd';
import { MailOutlined, PhoneOutlined, TeamOutlined, UserOutlined } from '@ant-design/icons';
import {
    filterYardContactOption,
    getYardContactAutocompleteOptions,
    getYardContactRows
} from '../utils/yardContactOptions';

const YardContactFields = ({
    yardId,
    yardDetails,
    yardDraft = {},
    onFieldChange,
    onContactSelect
}) => {
    const contactRows = getYardContactRows(yardDetails);

    const handleSelect = (_, option) => {
        onContactSelect?.(yardId, option);
    };

    const renderAutoComplete = ({ field, label, placeholder, icon }) => (
        <Col xs={24} md={12}>
            <Form.Item label={label} style={{ marginBottom: 18 }}>
                <AutoComplete
                    value={yardDraft[field] || ''}
                    options={getYardContactAutocompleteOptions(contactRows, field)}
                    onChange={(value) => onFieldChange?.(yardId, field, value)}
                    onSelect={handleSelect}
                    filterOption={filterYardContactOption}
                >
                    <Input prefix={icon} placeholder={placeholder} allowClear />
                </AutoComplete>
            </Form.Item>
        </Col>
    );

    return (
        <>
            <div className="yard-assignment-section-heading">
                <span className="yard-assignment-section-heading__icon"><TeamOutlined /></span>
                <span className="yard-assignment-section-heading__copy">
                    <strong>Contact Details</strong>
                </span>
            </div>

            <Row gutter={[18, 2]}>
                {renderAutoComplete({
                    field: 'contactPerson',
                    label: 'Contact Person',
                    placeholder: 'Select or enter contact person',
                    icon: <UserOutlined />
                })}
                {renderAutoComplete({
                    field: 'contactEmail',
                    label: 'Email',
                    placeholder: 'Select or enter email',
                    icon: <MailOutlined />
                })}
                {renderAutoComplete({
                    field: 'contactNumber',
                    label: 'Contact Number',
                    placeholder: 'Select or enter contact number',
                    icon: <PhoneOutlined />
                })}
                {renderAutoComplete({
                    field: 'contactPersonExtension',
                    label: 'Extension (Optional)',
                    placeholder: 'Select or enter extension',
                    icon: <PhoneOutlined />
                })}
            </Row>
        </>
    );
};

export default YardContactFields;
